// extracted by mini-css-extract-plugin
export default {"root":"DarkmodeCheckbox_root__-r6Yr"};